import { render, staticRenderFns } from "./b-area.vue?vue&type=template&id=5798ce23&scoped=true&"
import script from "./b-area.vue?vue&type=script&lang=js&"
export * from "./b-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798ce23",
  null
  
)

export default component.exports